import React, { useState, useEffect } from "react";
import moment from "moment";
import { Link } from "react-router-dom";


export default function NewsPaperJobs() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    
    axios
      .get(constvar.api_url + "jobs/newspaper", { signal: controller.signal })
      .then((res) => {
        if (!isMounted) return;
        if (res.data.status === "success") setNews(res.data.data.data || []);
      })
      .catch(error => {
        if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("Failed to load news:", error);
        }
      })
      .finally(() => setLoading(false));

    // Cleanup: cancel request if component unmounts
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  if (!loading && news.length === 0) return null;

  return (
    <section className="sf-section sf-section-light newspaper-jobs">
      <div className="sf-container">
        <div className="sf-section-header">
          <h2 className="sf-section-title">Newspaper Jobs</h2>
            <Link to="/job_search?newsPaperJob=true" className="sf-section-link">
              View All
            </Link>
        </div>

        {loading ? (
          <div className="sf-loading">
            <i className="fa fa-spinner fa-spin" /> Loading…
          </div>
        ) : (
          <div className="sf-news-grid">
            {news.slice(0,12).map((item, idx) => (
              <div key={item.id || idx} className="sf-news-card">
                <Link  key={item.id} to={`/jobs/${item.slug}`} className="sf-news-title">
                  {/* <span className="sf-news-title">{item.job_title}</span> */}
                  {item.job_title}
                </Link>
                {item.organization && (
                  <div className="sf-news-org">
                    {/* <i className="fa fa-building-o" style={{ marginRight: 4 }} /> */}
                    {item.organization}
                  </div>
                )}
                <div className="sf-news-meta">
                  <i className="fa fa-calendar-o" style={{ marginRight: 4 }} />
                  {moment(item.created_at).fromNow()}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
